var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Order from "../enums/OrderEnum";
var ProductSort = /** @class */ (function () {
    function ProductSort(products) {
        this.input = [];
        this.result = [];
        this.sortingMethod = {};
        this.cache = new Map();
        this.input = products.map(function (product) {
            return {
                id: product.id,
                name: product.name,
                price: product.getPriceWithDiscount(),
                type: product.type,
            };
        });
        this.result = products;
    }
    ProductSort.prototype.setSorting = function (sortingMethod) {
        var _this = this;
        if (sortingMethod === void 0) { sortingMethod = {}; }
        this.sortingMethod = sortingMethod;
        var sortingMethodKeys = Object.keys(this.sortingMethod);
        sortingMethodKeys.forEach(function (sortType) {
            _this.input = _this.SortbyKey(sortType, _this.sortingMethod[sortType]);
            var orderProductsAccordingToInput = [];
            _this.input.forEach(function (orderedProduct) {
                orderProductsAccordingToInput.push(__spreadArray([], _this.result, true).filter(function (product) {
                    return product.id == orderedProduct.id;
                })[0]);
            });
            _this.result = orderProductsAccordingToInput;
            _this.cache.set(sortingMethod, _this.result);
        });
    };
    ProductSort.prototype.getSorting = function () {
        return this.cache.get(this.sortingMethod);
    };
    ProductSort.prototype.SortbyKey = function (key, order) {
        var _this = this;
        if (order === Order.ASC) {
            return this.input.sort(function (a, b) {
                return _this.sortBy(a, b, key);
            });
        }
        else {
            return this.input.sort(function (a, b) {
                return _this.sortBy(b, a, key);
            });
        }
    };
    ProductSort.prototype.sortBy = function (a, b, key) {
        if (a[key] > b[key])
            return 1;
        if (a[key] < b[key])
            return -1;
        return 0;
    };
    return ProductSort;
}());
export default ProductSort;
